/*
Version 0.110

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2019
	24-07-2019
	- [CHANGED] trim() added, to be sure that the error message has no spaces
2018
	11-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_formhandling = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	/**
	None yet
	**/
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	// none
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
		this.formHandlingBefore = function(
			formname
		) {
			
			switch(formname) {
			
				default:
					
					// nothing
					
				break;
		
			}
			
		};
		
		this.formHandling = function(
			formaction,
			formname,
			data
		) {
				
			/**
			Error
			**/
			if(data.trim().substring(0,5) === 'Error') {
				
				/**
				Catch unusual PHP message
				**/
				errorMessage = data.split('§');
				
				/**
				fadeIn error message
				**/
				specific_interactions_formhandling.error(formname,errorMessage[1]);
				
				/**
				Cancel and reset the form 
				**/
				form.cancelForm(formaction);
				
			/**
			Success
			**/
			} else {
				
				switch(formname) {
				
					default:
						
						// data
						// $('html,body').scrollTop(0); don't scroll to top!
				
						$(formaction).html(data);
						processForm = 0;
						
					break;

					/*
					User
					User
					User
					User
					*/
					case 'login':
						
						/*
						If success then refresh page
						*/
						if(data == 1) {

							window.location.href = globalUrl + '/projecten';

						}

					break;
					
				}
			
			}
			
		};
		
		/**
		Callback: Radiobutton
		**/
		this.radiobuttonHandeling = function(t) {
			
			/**
			Catch the name
			**/
			var _this_radiobutton 			= $(t).data('name');
			var _this_radiobutton_value 	= $("input[name*=" + _this_radiobutton + "]").val();
			
			/**
			Callback
			**/
			switch(_this_radiobutton) {
				
				default:
				break;
				
			}
			
			
		};
		
		/**
		Callback: Checkbox
		**/
		this.checkboxHandeling = function(t,onoff) {
			
			/**
			Catch the name
			**/
			var _this_checkbox = $(t).data('name');
			
			/**
			Callback
			**/
			switch(_this_checkbox) {
				
				default:
				break;
				
			}
			
		};
		
		/**
		Callback: Select
		**/
		this.selectHandeling = function(t) {
			
			/**
			Catch the name
			**/
			var _this_selectbox 			= $(t).attr('name');
			var _this_selectbox_selected 	= $(t).val();
			
			/**
			Callback
			**/
			switch(_this_selectbox) {
				
				default:
				break;
				
			}
			
		};
		
		/**
		Upload Document / Image callback specifics
		**/
		this.uploaderCallback = function(
			callback,
			id,
			action,
			data
		) {

			var _image_sort_id;
			var _image_file;
			
			switch(callback) {
				
				default:
				break;

				case 'upload-image-before':

					_image_sort_id 	= id;
										
					if(action == 'progress') {
						$('#' + _image_sort_id + ' .js-upload-info').find('span').html(data + '%');
					}

					if(action == 'uploaded') {

						_image_file = globalUrl + '/img/uploads/fotos/vooraf/' + data;
						
						$('#' + _image_sort_id + ' .js-upload-info').html('<a href="' + _image_file + '"" target="_blank"><img src="' + _image_file + '" class="img-maxwidth"></a>');
						
						/*
						Show delete button
						*/
						$('#' + _image_sort_id).find('.js-button-delete-image').show();

						/*
						Hide upload button
						*/
						$('#' + _image_sort_id).find('.upload-button').hide();

						/*
						Disable the field
						*/
						_image_number	= _image_sort_id.split('-');
						_image_number	= _image_number[2];

						/*
						Save
						*/
						specific_photos.save(
							'before',
							_image_sort_id,
							data,
							$('.form-input-photo-before-filename-' + _image_number).val()
						);

						specific_photos.inputfield_disabled(
							'before',
							_image_number
						);

					}

				break;

				case 'upload-image-after':

					_image_sort_id = id;
										
					if(action == 'progress') {
						$('#' + _image_sort_id + ' .js-upload-info').find('span').html(data + '%');
					}

					if(action == 'uploaded') {

						_image_file = globalUrl + '/img/uploads/fotos/achteraf/' + data;
						
						$('#' + _image_sort_id + ' .js-upload-info').html('<a href="' + _image_file + '"" target="_blank"><img src="' + _image_file + '" class="img-maxwidth"></a>');
						
						/*
						Show delete button
						*/
						$('#' + _image_sort_id).find('.js-button-delete-image').show();

						/*
						Hide upload button
						*/
						$('#' + _image_sort_id).find('.upload-button').hide();

						/*
						Disable the field
						*/
						_image_number	= _image_sort_id.split('-');
						_image_number	= _image_number[2];
						
						/*
						Save
						*/
						specific_photos.save(
							'after',
							_image_sort_id,
							data,
							$('.form-input-photo-after-filename-' + _image_number).val()
						);

						specific_photos.inputfield_disabled(
							'before',
							_image_number
						);

					}

				break;

				case 'upload-image-deliveryform':

					_image_sort_id 	= id;
										
					if(action == 'progress') {
						$('#' + _image_sort_id + ' .js-upload-info').find('span').html(data + '%');
					}

					if(action == 'uploaded') {

						_image_file = globalUrl + '/img/uploads/fotos/oplevering/' + data;
						
						$('#' + _image_sort_id + ' .js-upload-info').html('<a href="' + _image_file + '"" target="_blank"><img src="' + _image_file + '" class="img-maxwidth"></a>');
						
						/*
						Show delete button
						*/
						$('#' + _image_sort_id).find('.js-button-delete-image').show();

						/*
						Hide upload button
						*/
						$('#' + _image_sort_id).find('.upload-button').hide();

						/*
						Disable the field
						*/
						_image_number	= _image_sort_id.split('-');
						_image_number	= _image_number[2];

						/*
						Save
						*/
						specific_photos.save(
							'deliveryform',
							_image_sort_id,
							data,
							$('.form-input-photo-deliveryform-filename-' + _image_number).val()
						);

						specific_photos.inputfield_disabled(
							'deliveryform',
							_image_number
						);

					}

				break;

				case 'upload-image-measuredocument':

					_image_sort_id 	= id;
										
					if(action == 'progress') {
						$('#' + _image_sort_id + ' .js-upload-info').find('span').html(data + '%');
					}

					if(action == 'uploaded') {

						_image_file = globalUrl + '/img/uploads/fotos/werktekening/' + data;
						
						$('#' + _image_sort_id + ' .js-upload-info').html('<a href="' + _image_file + '"" target="_blank"><img src="' + _image_file + '" class="img-maxwidth"></a>');
						
						/*
						Show delete button
						*/
						$('#' + _image_sort_id).find('.js-button-delete-image').show();

						/*
						Hide upload button
						*/
						$('#' + _image_sort_id).find('.upload-button').hide();

						/*
						Disable the field
						*/
						_image_number	= _image_sort_id.split('-');
						_image_number	= _image_number[2];

						/*
						Save
						*/
						specific_photos.save(
							'measuredocument',
							_image_sort_id,
							data,
							$('.form-input-photo-measuredocument-filename-' + _image_number).val()
						);

						specific_photos.inputfield_disabled(
							'measuredocument',
							_image_number
						);

					}

				break;

				case 'upload-pdf':
														
					if(action == 'progress') {
						$('#upload_document_pdf .js-upload-info').find('span').html(data + '%');
					}

					if(action == 'uploaded') {

						_pdf_file = globalUrl + '/doc/uploads/measuredocuments/' + data;
						
						$('#upload_document_pdf .js-upload-info').html('<a href="' + _pdf_file + '" target="_blank">' + data + '</a>');
						
						/*
						Show delete button
						*/
						$('#upload_document_pdf').find('.js-button-delete-document').show();

						/*
						Save
						*/
						specific_documents.save(
							data
						);

					}

				break;
				
			}
			
		};
		
		/**
		Upload Document / Image callback specifics delete
		**/
		this.uploaderCallbackDelete = function(
			callback,
			id
		) {
			
			switch(callback) {
				
				default:
				break;

				case 'upload-image-before':

					$('#' + id).find('.left').html('<div class="upload-info js-upload-info"><span>Nog geen foto toegevoegd</span></div><div class="upload-process js-upload-progress"><span>0%</span></div>');

					/*
					Delete
					*/
					specific_photos.delete(
						'before',
						id.substr(id.length - 1)
					);

					/*
					Enable the field & Hide Upload
					*/
					_image_number	= id.split('-');
					_image_number	= _image_number[2];
					
					specific_photos.inputfield_enabled(
						'before',
						_image_number
					);

				break;

				case 'upload-image-after':
				
					$('#' + id).find('.left').html('<div class="upload-info js-upload-info"><span>Nog geen foto toegevoegd</span></div><div class="upload-process js-upload-progress"><span>0%</span></div>');

					/*
					Delete
					*/
					specific_photos.delete(
						'after',
						id.substr(id.length - 1)
					);

					/*
					Enable the field & Hide Upload
					*/
					_image_number	= id.split('-');
					_image_number	= _image_number[2];
					
					specific_photos.inputfield_enabled(
						'after',
						_image_number
					);

				break;

				case 'upload-image-deliveryform':
				
					$('#' + id).find('.left').html('<div class="upload-info js-upload-info"><span>Nog geen foto toegevoegd</span></div><div class="upload-process js-upload-progress"><span>0%</span></div>');

					/*
					Delete
					*/
					specific_photos.delete(
						'deliveryform',
						id.substr(id.length - 1)
					);

					/*
					Enable the field & Hide Upload
					*/
					_image_number	= id.split('-');
					_image_number	= _image_number[2];
					
					specific_photos.inputfield_enabled(
						'deliveryform',
						_image_number
					);

				break;

				case 'upload-image-measuredocument':
				
					$('#' + id).find('.left').html('<div class="upload-info js-upload-info"><span>Nog geen foto toegevoegd</span></div><div class="upload-process js-upload-progress"><span>0%</span></div>');

					/*
					Delete
					*/
					specific_photos.delete(
						'measuredocument',
						id.substr(id.length - 1)
					);

					/*
					Enable the field & Hide Upload
					*/
					_image_number	= id.split('-');
					_image_number	= _image_number[2];
					
					specific_photos.inputfield_enabled(
						'measuredocument',
						_image_number
					);

				break;

				case 'upload-pdf':
				
					$('#upload_document_pdf').find('.left').html('<div class="upload-info js-upload-info"><span>Nog geen bestand toegevoegd</span></div><div class="upload-process js-upload-progress"><span>0%</span></div>');

					/*
					Delete
					*/
					specific_documents.delete();

				break;

				
			}
			
		};
		
		/**
		Error
		**/
		this.error = function(i,errormessage) { 
		
			switch(i) {
				
				default:
					modal.open('error',i,errormessage);
				break;
				
			}
		
		};
		
}).apply(specific_interactions_formhandling); 